import categorial from './categoricalOutcomeExamples';

export default { ...categorial };
